export const DOC_FLOW_BUILDING_FIELD_NAME = 'building'
